import React, { useCallback, useState } from 'react';
import { useTranslation } from "react-i18next";
import { Grid, CircularProgress } from '@mui/material';
import FilterListIcon from '@mui/icons-material/FilterList';
import DyanamicDropdown from 'components/Elements/DynamicDropdown';
import { useFilters } from '../FilterContext';
import { useServices } from './hooks/useServices';
import { useFilterInitialization } from './hooks/useFilterInitialization';

export const ServiceFilter = () => {
  const { t } = useTranslation();
  const { filterValues, updateFilter } = useFilters();
  const { siteAppID, customCaptions } = JSON.parse(localStorage.getItem("me") || sessionStorage.getItem("me") || '{}');

  const departmentFilter = filterValues.department;
  const timeframeFilter  = filterValues.timeframe;

  const [sortConfig, setSortConfig] = useState({
    // field: 'scheduledDate',
    field: 'workOrder',
    direction: 'asc',
  });

  const {
    services,
    isLoading,
    searchQuery,
    handleSearchChange,
    handleDropdownClick
  } = useServices(
    siteAppID,
    departmentFilter,
    timeframeFilter,
    updateFilter,
    filterValues,
    sortConfig.direction,    
    sortConfig.field,       
  );

  // Reset service when department changes 
  useFilterInitialization('service', [{}], {
    getDefaultValue: () => ({}),
    getParams: (svc) => ({ serviceId: svc.id || '' }),
    dependencies: [departmentFilter?.value?.id],
    resetOnDependencyChange: true,
  });

  const handleServiceChange = (service) => {
    if (!service?.id) {
      updateFilter('service', {}, { serviceId: '' });
      return;
    }

    const display = {
      ...service,
      displayDetails: `${service.modelName || ''} ${service.model || ''} - ${service.siteAssetName || ''} - ${service.interval || ''} - ${service.role || ''}`
    };

    updateFilter('service', display, { serviceId: service.id });
  };

  const handleServerSideSort = useCallback((clickedField) => {
    setSortConfig(prev => {
      // If clicking the same column - toggle direction
      if (prev.field === clickedField) {
        return {
          field: clickedField,
          direction: prev.direction === 'asc' ? 'desc' : 'asc',
        };
      }
      // New column - sort ascending by default
      return {
        field: clickedField,
        direction: 'asc',
      };
    });
  }, []);

  return (
    <Grid item lg={3} md={6} xs={12} sx={{ position: 'relative' }}>
      {isLoading && (
        <CircularProgress
          size={20}
          sx={{ position: 'absolute', right: '40px', top: '32px', zIndex: 1 }}
        />
      )}

      <DyanamicDropdown
        width="100%"
        dataSource={services}
        dataHeader={[
          { id: 1, name: customCaptions?.workOrder || 'Work Order' },
          { id: 3, name: customCaptions?.department || 'Department' },
        ]}
        showHeader
        columns={[
          { id: 1, name: 'workOrder', minWidth: '130px' },
          { id: 3, name: 'departmentName', minWidth: '150px' },
        ]}
        columnsMinWidths={[140, 150]}
        placeholder={t("placeholder.searchForEntity", { entity: customCaptions?.workOrder || 'Work Order' })}
        onChange={handleServiceChange}
        selectdValueToshow="workOrder"
        selectedValue={filterValues.service?.value || {}}
        label={t("label.filterByEntity", { entity: customCaptions?.workOrder || 'Work Order' })}
        icon={<FilterListIcon style={{ color: 'rgb(48, 122, 215)' }} />}
        required
        showBorderColor
        isServerSide
        handleServerSideSearch={handleSearchChange}
        PreloadedSearch={searchQuery}
        dropDownActiveWidth="500px"
        fetchData={handleDropdownClick}
        handleServerSideSort={handleServerSideSort}      
      />
    </Grid>
  );
};
